import type { UIMessageChunk } from '../ui-message-stream/ui-message-chunks';
import {
  type HttpChatTransportInitOptions,
  HttpChatTransport,
} from './http-chat-transport';
import { transformTextToUiMessageStream } from './transform-text-to-ui-message-stream';
import type { UIMessage } from './ui-messages';

export class TextStreamChatTransport<
  UI_MESSAGE extends UIMessage,
> extends HttpChatTransport<UI_MESSAGE> {
  constructor(options: HttpChatTransportInitOptions<UI_MESSAGE> = {}) {
    super(options);
  }

  protected processResponseStream(
    stream: ReadableStream<Uint8Array<ArrayBufferLike>>,
  ): ReadableStream<UIMessageChunk> {
    return transformTextToUiMessageStream({
      stream: stream.pipeThrough(new TextDecoderStream()),
    });
  }
}
